import React, { Component } from 'react';
import Axios from 'axios';
import ProductSelector from '../product-selector/ProductSelector';
const elementary = require('../../vendor/elementary.js');

class FRPSelector extends Component {
	constructor(props) {
		super(props);

		this.state = {
			title: 'Find a Flat Roof Product',
			filters: [],
			products: [],
			matchedMaterials: [],
			matchedSubstrates: [],
			mod: 'flat-roof-products'
		}

		this.handleMaterialFilterChange  = this.handleMaterialFilterChange.bind(this);
		this.handleSubstrateFilterChange = this.handleSubstrateFilterChange.bind(this);
	}

	componentDidMount() {
		var compScope = this;

		// Get selector filters data
		Axios.get(this.props.filtersUrl)
			.then(function(response) {
				compScope.setState({
					filters: response.data
				})
			})
			.catch(function(error) {
				console.log('Error:', error);
			});

		// Get selector product data
		Axios.get(this.props.productTypesUrl)
			.then(function(response) {
				compScope.setState({
					products: response.data
				});
			})
			.catch(function(error) {
				console.log('Error:', error);
			});
	}

	handleMaterialFilterChange(materialId)
	{
		console.log('Material ID', materialId);

		var matchedMaterials = [materialId];

		// Set state to matchedSubstrates
		this.setState({
			matchedMaterials: matchedMaterials
		})
	}

	handleSubstrateFilterChange(substrateId)
	{
		console.log('Substrate ID', substrateId);

		// Find text for this substrate
		var substrates = this.state.filters[2].options;
		var selected   = substrates.find(function(selected) {
			return selected.value === substrateId;
		});

		var range = this.getMinMaxFromName(selected.name);

		var matchedSubstrates = [substrateId];

		// If range has been found
		if (range !== false)
		{
			// Loop through all substrates
			for (var i = 0; i < substrates.length; i++)
			{
				// Only get ranges for substrates excluding selected one
				if (substrates[i].value !== substrateId)
				{
					// Get range for substrate
					var sRange = this.getMinMaxFromName(substrates[i].name);

					// If range is found...
					if (sRange !== false)
					{
						// If this substrate range falls inside selected substrate range...
						if (sRange[0] <= range[0] && sRange[1] >= range[1])
						{
							// ...add to array of matchedSubstrates
							matchedSubstrates.push(substrates[i].value);
						}
					}
				}
			}
		}

		// Set state to matchedSubstrates
		this.setState({
			matchedSubstrates: matchedSubstrates
		})
	}

	/**
	 * When passed a string containing a number range, returns range as array
	 * @param  {string} name    The string containing the range
	 * @return {array/boolean}  Array containing range numbers, or false if no range found
	 */
	getMinMaxFromName(name)
	{
		// If name contains 'Steel' and '-' strings, get thickness range
		if (name.includes('Steel') && name.includes('-'))
		{
			var arr = name.split(' ');
			var min = parseFloat(arr[1]);
			var max = parseFloat(arr[3]);

			return [min, max];
		}
		else
		{
			return false;
		}
	}

	render() {
		return (
			<div>
				<ProductSelector
					title={ this.state.title }
					filters={ this.state.filters }
					products={ this.state.products }
					productTypes={true}
					matchedMaterials={ this.state.matchedMaterials } matchedSubstrates={ this.state.matchedSubstrates }
					mod={ this.state.mod }
					onMaterialFilterChange={ this.handleMaterialFilterChange }
					onSubstrateFilterChange={ this.handleSubstrateFilterChange } />
			</div>
		);
	}
}

export default FRPSelector;
